import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer className="footer">
      <span>Mark McKenna 2020</span>
    </footer>
  );
}

export default Footer;
